import React from 'react';

import { Typography, Button } from '@mui/material';

import { ReactComponent as CheckIconGray } from '../../../../common/assets/icons/check_icon_gray.svg';
import { ReactComponent as CheckIconWhite } from '../../../../common/assets/icons/checkmark_icon_white.svg';

type Props = {
  isDisabled: boolean;
  onClick: (select: boolean) => void;
  hasSelectedAll: boolean;
};

const UseAllButton: React.FC<Props> = ({
  isDisabled,
  onClick,
  hasSelectedAll,
}) => {
  return (
    <Button
      disabled={isDisabled}
      onClick={() => {
        onClick(!hasSelectedAll);
      }}
      variant='outlined'
      color='secondary'
      startIcon={hasSelectedAll ? <CheckIconWhite /> : <CheckIconGray />}
      sx={{
        borderRadius: '40px',
        height: '40px',
        padding: '0 16px',
        backgroundColor: hasSelectedAll ? 'darkBlue.main' : 'transparent',
        '&:hover': {
          backgroundColor: hasSelectedAll ? 'darkBlue.main' : 'transparent',
          borderColor: 'black',
        },
      }}
    >
      <Typography color={hasSelectedAll ? 'white' : 'rgba(0, 33, 69, 0.5)'}>
        Use All
      </Typography>
    </Button>
  );
};

export default UseAllButton;
